// extracted by mini-css-extract-plugin
export default {"image_container":"right_image_container__tqLJW","img":"right_img__s+zMj","oldCoord":"right_oldCoord__n4P+c"};